module.exports = __webpack_public_path__ + "illustration-truck-home-gTq__nx.webp";